
import { ThreeView, webcadDefines, ModelInfo } from '../../../view3d/webcad';
import * as THREE from 'three';
import { MeshBasicMaterial } from 'three';
import { OctreeManager } from '../Octree/OctreeManager';
import * as marietta from '../../../../marietta';
import { RayIntersection } from '../Octree/RayIntersection';
import { OBBManager } from '../OBBManager';

export interface pinData {
    id: string,
    guid: string,
    floor: number,
    width: number,
    height: number,
    text: string,
    x: number,
    y: number,
    z: number
}

export class AddPin {

    private object: THREE.Object3D;

    private pinRadius = 0.05;

    constructor() {}

    public click(target: THREE.Object3D) {
        // 形状作成
        this.createPinGeometory(target.userData.sub_type);
        // 配置
        this.arrangement();

        // 画角内判定
        ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
        ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);

        // アイテム登録
        this.regist(this.object);
    }

    private color(type) {
        if (type === webcadDefines.ExtrasSubType.INNERWALL) {
            return new THREE.Color('#0184ff');
        } else if (type === webcadDefines.ExtrasSubType.CEILING) {
            return new THREE.Color('#ff2a01');
        } else if (type === webcadDefines.ExtrasSubType.FLOOR) {
            return new THREE.Color('#01ff7f');
        }
        console.error('pin error', type);
    }

    private createMesh(color_: THREE.Color): THREE.Mesh {
        const geometry = new THREE.SphereGeometry(this.pinRadius);
        return new THREE.Mesh(geometry, new MeshBasicMaterial({ color: color_ }));
    }

    private createPinGeometory(type) {
        this.object = this.createMesh(this.color(type));
        // this.object.userData.pinData = 'pin';
        this.object.userData.obb = new OBBManager(this.object);
        ThreeView.get().wcItemmgr.addOtherShapes(this.object);
        ThreeView.get().wcItemmgr.addHouseData(this.object);
    }

    private creatModelInfo(object: THREE.Object3D, guid: string, type: webcadDefines.extraSubTypes) {
        const model: ModelInfo = new ModelInfo();
        model.setTranslate(object.position.x, object.position.y, object.position.z);
        model.setRotation(0, 0, 0);
        model.setScale(1, 1, 1);

        // model.reverse = false;

        model.type = 'pin';
        model.uuid = guid;

        model.typeExtras = webcadDefines.ExtrasType.PIN;
        model.subType = <string>type;

        return model;
    }

    // アイテム登録
    protected regist(object: THREE.Object3D): void {
        ThreeView.get().wcItemmgr.furnitureObjects.push(<THREE.Group>(object));
        ThreeView.get().wcItemmgr.registFloorObject(<THREE.Object3D>(object));
    }

    private arrangement() {
        const selectManager = ThreeView.get().ObjectSelectManager;
        const direction = selectManager.normal;
        const pos = selectManager.intersectPoint.clone().add(direction.multiplyScalar(0.05));
        // 配置
        this.object.position.copy(pos);

        // 2D連携：新規2DPin登録
        const guid = this.regist2DPin(selectManager.type, this.object.getWorldPosition(new THREE.Vector3()));

        this.object.userData.modelInfo = this.creatModelInfo(this.object, guid, selectManager.type);
    }

    //2D連携
    //新規2DPin登録
    private regist2DPin(type: webcadDefines.extraSubTypes, pos) {
        const index = [webcadDefines.ExtrasSubType.CEILING,
            webcadDefines.ExtrasSubType.INNERWALL,
            webcadDefines.ExtrasSubType.FLOOR].indexOf(<string>type);
        if (index < 0) {
            console.error('create pin error', type);
        }

        const extras = ThreeView.get().wcItemmgr.GltfExtras;
        const center = marietta.webcad.WebCADGlobal.itemManager.changePoint(extras.model_center[0], extras.model_center[1]);

        const floor = marietta.view3d.webcad.WebCadItemManager.getFloorFromPoint(ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3()));

        const x = pos.x * 1000 + center.x;
        const y = pos.z * 1000 + center.y;
        let z = 0;

        const pinID = marietta.webcad.WebCADGlobal.getPinTextId(index+1);
        if (marietta.webcad.WebCADGlobal.isWallPinText(pinID)) {
            z = pos.y * 1000;
        }
        return marietta.webcad.WebCADGlobal.itemManager.add2Ditem(pinID, x, y, z, 0, floor, null);
    }

    private raycast(pos: THREE.Vector3, type: webcadDefines.extraSubTypes): THREE.Vector3 {

        const direction = (type: webcadDefines.extraSubTypes) => {
            if (type == webcadDefines.ExtrasSubType.CEILING)
                return new THREE.Vector3(0, 1, 0);
            if (type == webcadDefines.ExtrasSubType.FLOOR) {
                return new THREE.Vector3(0, -1, 0);
            }
            return new THREE.Vector3(0, -1, 0);
        }

        const dir = direction(type);
        const rayCaster = new THREE.Raycaster(pos, dir);

        const hitObjects = new RayIntersection(rayCaster).getTargets(ThreeView.get().OctreeManager);

        if (hitObjects.length == 0) {
            const dir_ = new THREE.Vector3(0, -1, 0);
            rayCaster.set(pos, dir_);
            const hitObjects = new RayIntersection(rayCaster).getTargets(ThreeView.get().OctreeManager);
            if (hitObjects.length == 0) return undefined;
            return hitObjects[0].point.clone().add(dir_.negate().multiplyScalar(this.pinRadius));
        }

        // raycastして当たった位置からピンの設置位置を求める
        return hitObjects[0].point.clone().add(dir.negate().multiplyScalar(this.pinRadius));
    }

    public set(pin: pinData) {

        const idtype: webcadDefines.extraSubTypes = [webcadDefines.ExtrasSubType.CEILING,
                        webcadDefines.ExtrasSubType.INNERWALL,
                        webcadDefines.ExtrasSubType.FLOOR];

        const unit = ((v) => {
            return v / 1000;
        });

        let pinNum = marietta.WebCADGlobal.PinTextItemNumber(pin.id);
        if (pinNum <= 0) pinNum = marietta.WebCADGlobal.PinPanoramaItemNumber(pin.id);
        if (pinNum <= 0) {
            console.error('Pin ID Error ', pin.id);
        }
        const type = idtype[pinNum-1];

        this.createPinGeometory(type);

        const extras = ThreeView.get().wcItemmgr.GltfExtras;
        const center = marietta.webcad.WebCADGlobal.itemManager.changePoint(extras.model_center[0], extras.model_center[1]);

        const p1 = new THREE.Vector2(pin.x, pin.y);
        const p2 = new THREE.Vector2(center.x, center.y);
        const pos = p1.clone().sub(p2);

        // 壁付のPIN
        if (type == webcadDefines.ExtrasSubType.INNERWALL) {
            this.object.position.set(unit(pos.x), unit(pin.z), unit(pos.y));
        } else {
            const floorHeight = ThreeView.get().wcItemmgr.floorToHeight(pin.floor);
            const h = floorHeight + webcadDefines.WebCadCameraDefs.wlkthHeight;
            const point3d = new THREE.Vector3(unit(pos.x), h, unit(pos.y));
            const hitpoint = this.raycast(point3d, type);
            if (hitpoint == null) return;
            this.object.position.set(hitpoint.x, hitpoint.y, hitpoint.z);
        }

        // this.object.userData.pin_guid = pin.guid;
        this.object.userData.modelInfo = this.creatModelInfo(this.object, pin.guid, type);

        // 画角内判定
        ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
        ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);

        this.regist(this.object);
    }

}
